export const SEASON_FIGHTS_USECASE_ERROR_MESSAGES = {
  RETRIEVAL_FAILED:
    'No events scheduled for this season yet. Please select another season.',
};
